/** Bilingual UI text: t("English", "中文"), same rule as the original L(e, z). Default language: Chinese. */
import { L, type Lang } from "@ic/engine";
import { useStore } from "../store.ts";

export function useT() {
  const lang = useStore((s) => s.lang);
  return (en: string, zh?: string) => L(lang, en, zh);
}

export const tFor = (lang: Lang) => (en: string, zh?: string) => L(lang, en, zh);
